/**
 * Die Grundfläche des Leitstands.
 *
 * Jede Seite der Verwaltungsebene wird hierin gewickelt. Der Wrapper tut
 * zwei Dinge, die man leicht vergisst:
 *
 *   1. Er färbt das <body>-Element mit. Ohne das blitzt beim Überscrollen
 *      der helle Grund der Erfassung durch — auf macOS bei jedem Wischen
 *      über das Seitenende hinaus.
 *   2. Er stellt das Farbschema der Seite auf dunkel (`color-scheme`),
 *      damit Bildlaufleisten und Formularelemente des Browsers dazu passen
 *      statt hell zu bleiben.
 *
 * Beides wird beim Verlassen zurückgenommen — die Erfassung an den
 * Stationen bleibt hell und darf davon nichts abbekommen.
 */

import { useEffect } from 'react';
import type { ReactNode } from 'react';

export function LeitstandFlaeche({ children }: { children: ReactNode }) {
  useEffect(() => {
    const wurzel = document.documentElement;
    wurzel.dataset.bereich = 'leitstand';
    return () => {
      delete wurzel.dataset.bereich;
    };
  }, []);

  return <div className="min-h-screen bg-grund text-tinte">{children}</div>;
}
